import React, { useState, useEffect, useRef, ReactElement } from 'react';
import { LocationDetailData, Tab } from '../../types';
import './LocationDetailAttributesTile.scss';

interface LocationDetailAttributesTileProps {
    location: LocationDetailData;
}

const LocationDetailAttributesTile = ({ location }: LocationDetailAttributesTileProps): ReactElement => {

    return (
        // No card shell here, unlike Contacts / Files / Links: those repeat a card per item,
        // whereas this tab has exactly one, so the card was a second box drawn just inside
        // the sidebar's own and enclosing the entire tab body.
        <div className='location-detail-attributes-tile'>
            <div className='row g-0'>
                <div className='col-6 field-label'>
                    Management Company
                </div>

                <div className='col-6 field-label'>
                    Region
                </div>
            </div>
            <div className='row g-0 mb-4'>
                <div className='col-6 field-value'>
                    {location.managementCompanyName}
                </div>

                <div className='col-6 field-value'>
                    {location.regionName}
                </div>
            </div>

            <div className='row g-0'>
                <div className='col-6 field-label'>
                    Brand
                </div>

                <div className='col-6 field-label'>
                    Property Type
                </div>
            </div>
            <div className='row g-0'>
                <div className='col-6 field-value'>
                    {location.brandName}
                </div>

                <div className='col-6 field-value'>
                    {location.typeName}
                </div>
            </div>
        </div>
    );
};

export default LocationDetailAttributesTile;
